<template>
    <div class="inner with-content">
        <div class="headline">
            <h1>{{$t('contracts.create.headline')}}</h1>
        </div>
        <div class="upload-container small">
            <div class="top">
                <h2>{{$t('propertyselector.headline')}}</h2>
                <p>{{$t('propertyselector.text')}}</p>
            </div>
            <PropertySelector v-model="selectedPropertyId" url="/properties/add?return=legacy-contract" />
            <button class="purple continue" disabled @click.prevent="nextStep">
                <span v-if="state === 'loading'">{{$t('property.loading.message')}}</span>
                <span v-else>{{$t('button.continue')}}</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {store} from "../../store";
    import {mapGetters} from 'vuex';
    import PropertySelector from './../../components/PropertySelector.vue';
    import createEntity from "../../mixins/create-entity";
    export default {
        mixins: [createEntity],
        async beforeRouteEnter(to, from, next){
            store.dispatch('fetchSingleProperty', null);
            next();
        },
        data: () => ({
            state: 'ready',
            selectedPropertyId: null
        }),
        components: {
            PropertySelector
        },
        computed:{
            ...mapGetters([
                'getProperties',
                'getSingleProperty'
            ])
        },
        methods: {
            nextStep(){
                this.state = 'loading';
                this.$store.dispatch('fetchSingleProperty', this.selectedPropertyId);
                this.$router.push('/contracts/add');
            }
        },
        created(){
            if (this.$route.query.property) {
                this.selectedPropertyId = this.$route.query.property;
                this.nextStep();
            }
        }
    }
</script>
